package com.ervasstudio.tracoemovimento.util

import com.ervasstudio.tracoemovimento.model.GoogleUser

sealed interface GoogleSignInResult {
    data class Success(val user: GoogleUser) : GoogleSignInResult
    data class Error(val code: String?, val message: String) : GoogleSignInResult
}